import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "PstTeachingCallout" */ "./lazyIndex"), { name: "PstTeachingCallout" });

export const LazyPstTeachingCallout: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.PstTeachingCallout);
